import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];
  static values = {
    url: String,
  };

  connect() {
    window.modalController = this;
    document.addEventListener("click", this.handleBodyClick);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  initialize() {
    this.handleBodyClick = this.handleBodyClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.handleBodyClick);
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleBodyClick(event) {
    if (
      !this.element.classList.contains("hidden") &&
      !event.target.closest(".modal-content") &&
      !event.target.closest('[data-action*="modal#"]')
    ) {
      this.close();
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
      this.close();
    }
  }

  open(eventOrUrl) {
    if (typeof eventOrUrl === "string") {
      this.openModal(eventOrUrl);
      return;
    }

    const event = eventOrUrl;
    if (event) event.preventDefault();

    const url =
      event.currentTarget.getAttribute("data-modal-url") || this.urlValue;

    if (url) {
      const dropdown = event.currentTarget.closest(
        '[data-controller="dropdown"]'
      );
      if (dropdown) {
        const menu = dropdown.querySelector('[data-dropdown-target="menu"]');
        if (menu && !menu.classList.contains("hidden")) {
          menu.classList.add("hidden");
        }
      }

      this.openModal(url);
    }
  }

  openModal(url) {
    const modalElement = this.element;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        modalElement.innerHTML = html;
        modalElement.classList.remove("hidden");
        document.body.classList.add("overflow-hidden");
      })
      .catch((error) => console.error("Error loading modal:", error));
  }

  close() {
    this.element.innerHTML = "";
    this.element.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }
}
